module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAADCAYAAACnI+4yAAAAGUlEQVQImWNUn/v+PwMJgIkUxaRrYGBgAACGZwK4TPyXgwAAAABJRU5ErkJggg=="